import * as React from 'react';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    background: 'transparent',
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&::before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));
const AccordionExpandIcon = ({accordionData}) => {

    const [expanded, setExpanded] = React.useState();

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    return (
        <div style={{borderRadius: '2px'}}>
            {accordionData.map((item) => (
                <Accordion
                    key={item.id}
                    expanded={expanded === `panel${item.id}`}
                    onChange={handleChange(`panel${item.id}`)}
                >
                    <AccordionSummary
                        aria-controls={`panel${item.id}d-content`}
                        id={`panel${item.id}d-header`}
                    >
                        <h4>{item.title}</h4>
                    </AccordionSummary>
                    <AccordionDetails>
                        {item.price &&
                        (
                            <div>
                                <h4 style={{color:"#9f0f91"}}>Արժեքը՝ {item.price} դրամ</h4>
                                <br/>
                            </div>
                        )
                        }
                        <p>{item.content}</p>
                    </AccordionDetails>
                </Accordion>
            ))}
        </div>
    );
}

export default AccordionExpandIcon;
